import { headerDropdown } from "./components/headerDropdown.js";
import { detailsSwiper } from "./components/detailsSwiper.js";
import { aboutVideo } from "./components/aboutVideo.js";
import { scrollAnimations } from "./components/scrollAnimations.js";
import { disabledButtons } from "./components/disabledButtons.js";

import { burger } from './functions/burger.js';

window.addEventListener('load', () => {
  headerDropdown();
  detailsSwiper();
  aboutVideo();
  scrollAnimations();
  disabledButtons();

  const loader = document.querySelector('.loader');

  setTimeout(() => {
    loader.classList.add('loader--hide');
    setTimeout(() => {
      loader.remove();
    }, 1000);
  }, 500);
});
